export const normalizeFavouriteUrl = (url: string): string => {
  if (!url) return '';
  const decoded = decodeURIComponent(url).replace(/ /g, '%20');
  const [path, query] = decoded.split('?');
  if (!query) return path;
  const params = query.split('&').filter(p => {
    const key = p.split('=')[0];
    if (key === 'finger_size') return false;
    if (key === 'size' && /^\d+\.?\d*$/.test(p.split('=')[1] || '')) return false;
    return true;
  }).sort();
  return params.length ? `${path}?${params.join('&')}` : path;
};

export const isFavouriteUrlMatch = (urlA: string, urlB: string): boolean => {
  const normA = normalizeFavouriteUrl(urlA);
  const normB = normalizeFavouriteUrl(urlB);
  const [pathA, queryA] = normA.split('?');
  const [pathB, queryB] = normB.split('?');
  if (pathA !== pathB) return false;

  const parseParams = (query?: string): Map<string, string> => {
    const map = new Map<string, string>();
    (query?.split('&').filter(Boolean) || []).forEach(p => {
      const eqIdx = p.indexOf('=');
      const k = eqIdx >= 0 ? p.slice(0, eqIdx) : p;
      const v = eqIdx >= 0 ? p.slice(eqIdx + 1) : '';
      if (k !== 'finish_type') map.set(k, v);
    });
    return map;
  };

  const mapA = parseParams(queryA);
  const mapB = parseParams(queryB);
  if (mapA.size === 0 || mapB.size === 0) return true;

  const aKeysSubsetB = Array.from(mapA.keys()).every(k => mapB.has(k));
  const bKeysSubsetA = Array.from(mapB.keys()).every(k => mapA.has(k));
  if (!aKeysSubsetB && !bKeysSubsetA) return false;

  const [ref, other] = aKeysSubsetB ? [mapA, mapB] : [mapB, mapA];
  return Array.from(ref.entries()).every(([k, vRef]) => {
    const vOther = other.get(k) ?? '';
    if (vRef === vOther) return true;
    const refVals = vRef.split(',');
    const otherVals = vOther.split(',');
    return refVals.every(v => otherVals.includes(v)) || otherVals.every(v => refVals.includes(v));
  });
};
